import React from 'react';
import { IconButton, Menu, MenuItem, Tooltip, Divider } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { BaseThreeDotMenuProps } from './types';
import { useBaseThreeDotMenu } from './useBaseThreeDotMenu';
import './BaseThreeDotMenu.scss';

export const BaseThreeDotMenu: React.FC<BaseThreeDotMenuProps> = ({
  menuItems,
  disabled = false,
  tooltip,
  size = 'small',
  className,
  iconClassName,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
  onMenuOpen,
  onMenuClose,
}) => {
  const {
    anchorEl,
    isOpen,
    handleMenuOpen,
    handleMenuClose,
    handleMenuItemClick,
  } = useBaseThreeDotMenu({
    onMenuOpen,
    onMenuClose,
  });

  const button = (
    <IconButton
      onClick={handleMenuOpen}
      disabled={disabled}
      size={size}
      className={`baseThreeDotMenuButton ${className || ''}`}
      aria-label="menu"
    >
      <MoreVertIcon className={iconClassName} />
    </IconButton>
  );

  return (
    <>
      {tooltip ? (
        <Tooltip title={tooltip} placement="top">
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleMenuClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        className="baseThreeDotMenu"
      >
        {menuItems.map(item => (
          <React.Fragment key={item.id}>
            <MenuItem
              onClick={() => handleMenuItemClick(item.onClick)}
              disabled={item.disabled}
              className={`baseThreeDotMenuItem ${item.destructive ? 'destructive' : ''}`}
            >
              {item.icon && <span className="menuItemIcon">{item.icon}</span>}
              <span className="menuItemLabel">{item.label}</span>
            </MenuItem>
            {item.divider && <Divider />}
          </React.Fragment>
        ))}
      </Menu>
    </>
  );
};
